module.exports = __webpack_public_path__ + "img/ardi_new_logo.8254b390.svg";